import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocalStorageService } from '../services/local-storage.service';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) {
  const storageService = inject(LocalStorageService);
  const token = storageService.getFromStorage('token');

  let newReq = req;
  if (token) {
    newReq = req.clone({
      headers: req.headers.append('Authorization', 'bearer ' + token),
    });
  }
  return next(newReq);
}
